module.exports = __webpack_public_path__ + "static/img/Pos_472.9c25f0f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Fertimo/Pos_472.gif
// module id = 9G4t
// module chunks = 1